module.exports = __webpack_public_path__ + "img/line-brands.cd09ff3.svg";